<template>
    <v-layout align-center justify-center class="editavatar_bg">
        <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin-top:5px;">
            {{ errorMessage }}
        </v-alert> 
        <v-toolbar fixed flat class="transparent" style="color:white;">
            <v-spacer></v-spacer>
            <v-toolbar-items>       
                <v-btn dark flat @click="closeDialog">Cancel</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm8 md4 :style="isMobile?'position:relative;height:100%;':''"> 
            <div class="text-xs-center" :style="isMobile?'position: absolute; top: 20%; width: 100%;':''">
                <!-- note css does not reflect on first load, inline style is workaround -->
                <video autoplay playsinline muted v-show="showCameraScreen" style="max-width:100%; width:auto; height:auto; margin: auto;"></video>
                <img src="" id="imgAttendancePic" v-show="showImage" style="max-width:100%; width:auto; height:auto; margin: auto;"> 
            </div>
            <div :class="isMobile?'img-controls':'text-xs-center'">
                <v-btn dark :block="isMobile?true:false" @click="takeScreenshot" :loading="loadingScreenshot" v-show="showScreenshot" title="Take Picture">
                    <v-icon>linked_camera</v-icon>&nbsp;Take Picture
                </v-btn>
                <v-btn dark :block="isMobile?true:false" @click="takeAgain" v-show="showSavePic" title="Take Another">
                    <v-icon>refresh</v-icon>&nbsp;Take Again
                </v-btn>
                <v-btn dark :block="isMobile?true:false" @click="savePicture" v-show="showSavePic" class="primary" title="Save Picture">
                    <v-icon>save</v-icon>&nbsp;Save
                </v-btn>
            </div>
        </v-flex>
    </v-layout>
</template>
<script>

export default {
    data () {
        return {
            error: false,
            errorMessage: '', 
            loading: false,   
            img: null,
            video: null,
            videoStream: null,    
            showCameraScreen: false,
            showScreenshot: false,
            showImage: false,
            showSavePic: false,
            loadingScreenshot: false,
            transDate: null,
            action: null
        }
    },
    methods: {
        async savePicture() {
            try {
                this.$emit('send', this.toBase64Image(this.img))
                this.$emit('update:dialogTakePic', false)

                this.closeDialog()
            } catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        toBase64Image(img) {
            // Create an empty canvas element
            var canvas = document.createElement("canvas");
            canvas.width = img.width
            canvas.height = img.height

            // Copy the image contents to the canvas
            var ctx = canvas.getContext("2d")
            ctx.drawImage(img, 0, 0)

            return canvas.toDataURL("image/png")
        },
        async takeScreenshot() {
            this.showImage = true

            this.img = document.getElementById('imgAttendancePic')
            this.canvas = document.createElement('canvas')

            this.canvas.width = this.video.videoWidth
            this.canvas.height = this.video.videoHeight
            this.canvas.getContext('2d').drawImage(this.video, 0, 0)
           
            // Other browsers will fall back to image/png
            this.img.src = this.canvas.toDataURL('image/png')
            this.img.width = this.video.videoWidth

            this.showCameraScreen = false
            this.showScreenshot = false
            this.showSavePic = true
        },
        turnOffDevice() {
            if (this.videoStream) {
                this.videoStream
                    .getTracks()
                    .forEach((track) => {
                        track.stop()
                    });
            }
        },
        takeAgain() {
            this.showImage = false
            this.showSavePic = false
            this.turnOffDevice()
            this.turnOnVideo(this.action, this.transDate)
        },
        turnOnVideo(action, transDate) {
            try {
                this.error = false
                this.transDate = transDate
                this.action = action
                this.showCameraScreen = true
                this.showScreenshot = true
                this.loadingScreenshot = true

                const constraints = {
                    video: {
                        width: {exact: 440}, 
                        height: {exact: 360}
                    }
                }
                this.video = document.querySelector('video');

                navigator.mediaDevices.getUserMedia(constraints)
                    .then((stream) => {                        
                        this.video.srcObject = stream
                        this.videoStream = stream
                        this.loadingScreenshot = false
                    });
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading = false
            }
        },
        fileAdded(file) {
            this.loading = true
        },
        closeDialog() {
            this.turnOffDevice()

            this.showCameraScreen = false
            this.showScreenshot = false
            this.showImage = false
            this.showSavePic = false
            
            this.$emit('update:dialogTakePic', false)   
        }
    },        
    created() {
        this.userId = this.$store.state.userId
    },
    computed: {
        isMobile() {
            return window.innerWidth < 800
        },
    },
    destroyed() {
        this.turnOffDevice()
    }
}
</script>
<style scoped>
.editavatar_bg {
    height: 100%;
    width: 100%;
    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: black;
}
.img-viewer {
    max-width: 100%;
    width: auto;
    height: auto;
    margin:auto;
}
.img-controls {
    position: absolute; 
    bottom: 0; 
    left: 50%; 
    transform: translateX(-50%); 
    width: 100%; 
    padding: 10px 10px 50px 10px;
}
</style>